import { render, staticRenderFns } from "./SPProfessionalServiceFields.vue?vue&type=template&id=65c9d12e&scoped=true&"
import script from "./SPProfessionalServiceFields.vue?vue&type=script&lang=ts&"
export * from "./SPProfessionalServiceFields.vue?vue&type=script&lang=ts&"
import style0 from "./SPProfessionalServiceFields.vue?vue&type=style&index=0&id=65c9d12e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c9d12e",
  null
  
)

export default component.exports